import { forwardRef } from "react";
import { MultiSelect } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const CollaboratorMultiSelect = forwardRef(
  ({ boardPermissions, initialValue, id, label, ...rest }, ref) => {
    const { i18n } = useTranslation(["CreateTaskModal"]);
    const userData = boardPermissions;
    const fields = {
      text: "FullName",
      value: "Id",
    };

    return (
      <MultiSelect
        ref={ref}
        value={initialValue ?? null}
        dataSource={userData?.filter((x) => x.FullName) ?? []}
        fields={fields}
        label={label}
        htmlFor={id}
        id={id}
        allowCustomValues={false}
        locale={i18n?.language}
        sortOrder="Ascending"
        {...rest}
      />
    );
  }
);
